import type { PopoverOptions } from '@familyjs/core/components';
import { popoverController } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-popover.js';
import { useCallback } from 'react';

import type { ReactComponentOrElement } from '../models/ReactComponentOrElement';

import type { HookOverlayOptions } from './HookOverlayOptions';
import { useOverlay } from './useOverlay';

// TODO(FW-2959): types

/**
 * A hook for presenting/dismissing an FmlPicker component
 * @param component The component that the popover will show. Can be a React Component, a functional component, or a JSX Element
 * @param componentProps The props that will be passed to the component, if required
 * @returns Returns the present and dismiss methods in an array
 */
export function useFmlPopover(component: ReactComponentOrElement, componentProps?: any): UseFmlPopoverResult {
  const controller = useOverlay<PopoverOptions, HTMLFmlPopoverElement>(
    'FmlPopover',
    popoverController,
    defineCustomElement,
    component,
    componentProps
  );

  const present = useCallback(
    (options: Omit<PopoverOptions, 'component' | 'componentProps'> & HookOverlayOptions = {}) => {
      controller.present(options as any);
    },
    [controller.present]
  );

  return [present, controller.dismiss];
}

export type UseFmlPopoverResult = [
  (options?: Omit<PopoverOptions, 'component' | 'componentProps'> & HookOverlayOptions) => void,
  /**
   * Dismisses the popover
   */
  (data?: any, role?: string) => void
];
